import React from 'react';
import {
  Box,
  Container,
  Button,
  Stack,
  Alert,
  AlertTitle,
  Typography,
  Paper
} from '@mui/material';
import { useAuth } from '../services/AuthService';
import { useNavigate } from 'react-router-dom';

const AuthenticationRequired = ({
  title = "Authentication Required",
  message = "You need to be logged in to access this feature. Join thousands of users on our platform!",
  loginButtonText = "Log In to Your Account",
  signupButtonText = "Create New Account",
  benefits = "✓ Free to join • ✓ Easy setup • ✓ Start in minutes",
  maxWidth = "md",
  returnTo = null
}) => {
  const { loginWithRedirect } = useAuth();
  const navigate = useNavigate();

  const handleLogin = () => {
    const options = returnTo ? { appState: { returnTo } } : {};
    loginWithRedirect(options);
  };

  const handleSignup = () => {
    const url = returnTo && returnTo !== '/' ? `/signup?returnTo=${encodeURIComponent(returnTo)}` : '/signup';
    navigate(url);
  };

  return (
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: 'background.default',
          py: { xs: 4, md: 6 },
          px: 2
        }}
      >
        <Container maxWidth={maxWidth}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, md: 4 },
              textAlign: 'center',
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'background.paper'
            }}
          >
            <Stack spacing={3}>
              <Alert severity="info" sx={{ textAlign: 'left' }}>
                <AlertTitle>{title}</AlertTitle>
                {message}
              </Alert>

              <Stack spacing={2} sx={{mx: 'auto', width: '100%' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleLogin}
                    size="large"
                    sx={{ width: '100%', maxWidth: 320 }}
                  >
                    {loginButtonText}
                  </Button>
                </Box>

                <Typography variant="body2" color="text.secondary">
                  Don't have an account?
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleSignup}
                    size="large"
                    sx={{ width: '100%', maxWidth: 320 }}
                  >
                    {signupButtonText}
                  </Button>
                </Box>

                {benefits && (
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
                    {benefits}
                  </Typography>
                )}
              </Stack>
            </Stack>
          </Paper>
        </Container>
      </Box>
  );
};

export default AuthenticationRequired;